import "./index.scss";
import React from "react";

function SubmitBtn({ value = "Submit", disabled = false }) {
  return (
    <div id="SubmitBtn">
      <input
        type="submit"
        value={value}
        className="btn-submit"
        disabled={disabled}
      />
    </div>
  );
}

export default SubmitBtn;
